import { doc, deleteDoc } from "firebase/firestore";
import db from "./firebase";

const deleteSingleDoc = async(id)=>{
    await deleteDoc(doc(db, "demoEntries",id));
}

export default deleteSingleDoc;